import { Hourglass, TriangleAlert, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * Overlay bloquant affiché pendant le lancement du live :
 * - `launching` : les flux egress se préparent.
 * - `failed` : échec réel du quorum, avec relance (`onRetry`) et fermeture possible
 *   (`onClose`) pour reprendre la main sur « Démarrer la session ».
 * Levé dès que le live est confirmé.
 */
export default function LiveLaunchOverlay({
  variant = 'launching',
  onRetry,
  onClose,
}: {
  variant?: 'launching' | 'failed';
  onRetry?: () => void;
  onClose?: () => void;
}) {
  const { t } = useTranslation('common');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#00000099] px-6">
      <div className="relative flex w-full max-w-3xl flex-col items-center gap-2 rounded-2xl bg-white p-6 text-center shadow-lg">
        {variant === 'failed' && onClose ? (
          <button
            type="button"
            onClick={onClose}
            aria-label={t('liveSettings.liveLaunch.close')}
            className="absolute right-4 top-4 text-[#0C0E21]/50 hover:text-[#0C0E21]"
          >
            <X className="size-5" />
          </button>
        ) : null}
        {variant === 'failed' ? (
          <>
            <TriangleAlert className="size-6 text-red-500" aria-hidden />
            <p className="text-3xl font-semibold text-[#0C0E21]">
              {t('liveSettings.liveLaunch.errorTitle')}
            </p>
            <p className="text-sm text-secondary">{t('liveSettings.liveLaunch.errorBody')}</p>
            {onRetry ? (
              <Button type="button" onClick={onRetry} className="mt-3">
                {t('liveSettings.liveLaunch.retry')}
              </Button>
            ) : null}
          </>
        ) : (
          <>
            <Hourglass className="size-6 animate-hourglass-flip text-[#2C6CFF]" aria-hidden />
            <p className="text-3xl font-semibold text-[#0C0E21]">
              {t('liveSettings.liveLaunch.title')}
            </p>
            <p className="text-sm text-secondary">{t('liveSettings.liveLaunch.body')}</p>
          </>
        )}
      </div>
    </div>
  );
}
